import { z } from 'zod';

export const updateInstitutionSchema = z.object({
  display_name: z.string().min(1).optional(),
  address: z.string().min(1).optional(),
  city: z.string().min(1).optional(),
  state: z.string().min(1).optional(),
  zip_code: z.string().min(1).optional(),
  country: z.string().min(1).optional(),
  company_registration: z.string().min(1).optional(),
  avatar_url: z.string().optional(),
  avatar: z.string().optional(),
});

export type UpdateInstitutionPayload = z.infer<typeof updateInstitutionSchema>;
